import { SET_COURT_APPLICATION } from './action-types';
import { CLEAR_COURT_APPLICATION } from './action-types';

export const setCourtApplication = data => dispatch => {
  dispatch({
    type: SET_COURT_APPLICATION,
    data
  });
  return Promise.resolve();
};

export const clearCourtApplication = () => ({
  type: CLEAR_COURT_APPLICATION
});



// WEBPACK FOOTER //
// ./src/actions/courtApplication-actions.js